import React from 'react'
import Hero from '../components/Hero.jsx'
import Story from '../components/Story.jsx'
import Menu from '../components/Menu.jsx'
import Location from '../components/Location.jsx'
import Reviews from '../components/Reviews.jsx'

function LandingPage() {
  return (
    <>
      <Hero />
      <Story />
      <Menu />
      <Location />
      <Reviews />
    </>
  )
}

export default LandingPage
